import type { InstallInput } from '../../types/velociraptor-settings'
import { AdminCredentialsFields } from './AdminCredentialsFields'
import { DeploymentTypeSelector } from './DeploymentTypeSelector'
import { ExternalCredentialsBlock } from './ExternalCredentialsBlock'
import { InstallSubmitButton } from './InstallSubmitButton'
import { LocalBinaryFields } from './LocalBinaryFields'
import { PortConfigSection } from './PortConfigSection'
import { useInstallFormState } from './use-install-form-state'

interface InstallFormProps {
  onInstall: (input: InstallInput) => Promise<void>
  installing: boolean
}

export function InstallForm({ onInstall, installing }: InstallFormProps): React.ReactElement {
  const state = useInstallFormState({ installing })

  const handleSubmit = async (ev: React.FormEvent): Promise<void> => {
    ev.preventDefault()
    await onInstall(state.buildInstallInput())
  }

  return (
    <form
      onSubmit={(ev) => {
        void handleSubmit(ev)
      }}
      className="space-y-6"
    >
      <DeploymentTypeSelector
        deploymentType={state.deploymentType}
        onChange={state.setDeploymentType}
      />
      {!state.isExternal && (
        <AdminCredentialsFields
          adminUsername={state.adminUsername}
          adminPassword={state.adminPassword}
          setAdminUsername={state.setAdminUsername}
          setAdminPassword={state.setAdminPassword}
        />
      )}
      <PortConfigSection
        apiPort={state.apiPort}
        guiPort={state.guiPort}
        frontendPort={state.frontendPort}
        setApiPort={state.setApiPort}
        setGuiPort={state.setGuiPort}
        setFrontendPort={state.setFrontendPort}
        portAvailability={state.portAvailability}
      />
      {state.isLocalBinary && (
        <LocalBinaryFields
          binaryPath={state.binaryPath}
          datastorePath={state.datastorePath}
          setBinaryPath={state.setBinaryPath}
          setDatastorePath={state.setDatastorePath}
        />
      )}
      {state.isExternal && (
        <ExternalCredentialsBlock
          yamlText={state.yamlText}
          yamlError={state.yamlError}
          credentialsFromEnv={state.credentialsFromEnv}
          onYamlChange={state.handleYamlChange}
          onEnvChange={state.setCredentialsFromEnv}
        />
      )}
      <InstallSubmitButton installing={installing} disabled={state.isSubmitDisabled} />
    </form>
  )
}
